<template>
  <div v-if="listaDeCampos">
    <div class="d-flex align-items-center">
      <SGPFormBotaoComponent
        fab
        text
        small
        color="black"        
        class="margin-right-18 margin-bottom-10"
        :to="{name: 'ctrl-formularios-dinamicos'}"
      >
        <SGPIconComponent>mdi-arrow-left</SGPIconComponent>
      </SGPFormBotaoComponent>
      <h3>{{ $route.params.id ? 'Editar formulário' : 'Criar novo formulário' }}</h3>
    </div>
    <div class="pa-3 pt-2 white" style="border-radius: 8px;">
      <div class="">
        <SGPFormInputComponent
          label="Nome do formulário"
          name="nome"
          class="d-block"
          stylized
          placeholderText="Digite aqui"
          v-model="titulo"
          solo
          data-vv-as="Nome do formulário"
          v-validate="'required|max:250'"
          :error="validationErrors.first('nome')"
        />
      </div>
    </div>

    <div class="pa-3 mt-5 pt-2 white" style="border-radius: 8px;">
      <h4 class="mt-4">Insira os campos do seu formulário</h4>
      <p>Você pode criar o seu formulário utilizando os campos existentes no sistema.</p>

      <draggable
        v-model="rows"
        draggable=".item"
        @start="isDragging=true"
        @end="isDragging=false;"
      >      
        <div class="item linha-formulario pa-3 mb-5" style="border-radius: 8px;" v-for="linha, index in rows" :key="index">
          <header style="display: flex; align-items: center; gap: 15px;cursor: move !important;">
            <strong>Colunas: </strong>

            <SGPFormSelectComponent              
              :listaDeOptions="colunasLinha"
              optionValue="value"
              optionLabel="text"              
              v-model="linha.colunas"
              @change="inserirCampoLinha(linha)"
              dense
              outlined
            />

            <SGPIconComponent
              @click="deletarLinha(index)"
              color="primary"
            >
              mdi-trash-can-outline
            </SGPIconComponent>
            <v-icon>
              mdi-drag-vertical
            </v-icon>
          </header>

          <div  class="mt-3 white" style="display: flex; align-items: center; border-radius: 8px;">

            <draggable
              v-model="linha.campos"
              draggable=".coluna"
              @start="isDragging=true"
              @end="isDragging=false;"
              class="d-flex"
              style="width: 100%;"
            > 

              <div v-for="campo, i in linha.campos" :key="campo" class="coluna pa-2 " style="width: 100%; gap: 10px;">
                <div class="d-flex">
                  <SGPFormAutocompleteComponent
                    name="tipo_campo"
                    :listaDeOptions="listaDeCampos"
                    optionLabel="label"
                    optionValue="id"
                    v-model="linha.campos[i].ctrl_campo_id"              
                    solo
                    placeholderText="Tipo do campo"
                    style="width: 100%;"
                    mostrarSelecione
                    @change="alimentaValorPadrao(linha.campos[i])"
                  />
                  <v-icon>
                    mdi-drag-vertical
                  </v-icon>
                </div>

                <div class="d-flex gap-10 align-items-center justify-content-space-between">
                  <SGPFormCheckboxComponent 
                    name="obrigatorio"
                    v-model="linha.campos[i].obrigatorio" 
                    label="Obrigatório"
                    class=""
                    stylized
                    solo
                    v-if="campo.ctrl_campo_id"
                  />

                  <SGPFormCheckboxComponent 
                    name="readonly"
                    v-model="linha.campos[i].readonly" 
                    label="Somente Leitura"
                    class=""
                    stylized
                    solo
                    v-if="campo.ctrl_campo_id"
                  />

                  <div class="conteiner-botao d-flex align-items-center justify-content-right">
                    <div class="mr-3 ml-2">
                      <CamposExpressoesComponent
                        @fecharModalExpressoesLogicas="campo.mostrar_expressoes = false"
                        :campoAtual="campo"
                        :formulario="rows"
                        :mostrarModal="campo.mostrar_expressoes"
                        v-if="campo.mostrar_expressoes"
                      />

                      <v-chip
                        @click="campo.mostrar_expressoes = true"
                        :outlined="!campo.expressoes_logicas.length"
                        pill
                        color="primary lighten-1"
                        v-if="campo.ctrl_campo_id"
                      >
                        <v-icon left>mdi-arrow-decision-outline </v-icon>
                        Regras
                      </v-chip>
                    </div>

                    <div v-if="campo.ctrl_campo_id && campo.ctrl_campo.tipo_campo == 'select'">
                      <SubcampoFormComponent
                        :campoAtual="campo"
                        :mostrarModal="campo.mostrar_subcampos"
                      />

                      <v-chip
                        @click="campo.mostrar_subcampos = true"
                        :outlined="!campo.ctrl_formulario_subcampos.length"
                        pill
                        class="text-white"
                        color="purple lighten-1"
                        
                      >
                        <SGPIconComponent left> mdi-file-tree </SGPIconComponent>
                        Subcampos
                      </v-chip>
                    </div>
                  </div>
                </div>

                <SGPFormAutocompleteComponent
                  v-if="['select', 'radio'].includes(linha.campos[i].ctrl_campo.tipo_campo)"
                  name="valor_padrao"
                  :listaDeOptions="linha.campos[i].options"
                  optionLabel="label"
                  optionValue="val"
                  v-model="linha.campos[i].valor_padrao"              
                  solo
                  placeholderText="Valor Padrão"
                  style="width: 100%;"
                  mostrarSelecione
                />

                <SGPFormInputComponent
                  v-if="['text'].includes(linha.campos[i].ctrl_campo.tipo_campo)"
                  name="nome"
                  class="d-block"
                  placeholder="Valor Padrão"
                  placeholderText="Valor Padrão"
                  v-model="linha.campos[i].valor_padrao"                  
                />

                <!-- CAMPOS COMPUTADOS -->
                <div v-if="campo.ctrl_campo_id" class="mt-3 pa-3" style="background: #f5f5f5; border-radius: 6px;">
                  <v-chip
                    @click="campo.is_computed = !campo.is_computed"
                    :outlined="!campo.is_computed"
                    pill
                    small
                    color="orange lighten-1"
                  >
                    <v-icon left small>mdi-calculator-variant</v-icon>
                    {{ campo.is_computed ? 'Campo Computado Ativado' : 'Tornar Campo Computado' }}
                  </v-chip>

                  <div v-if="campo.is_computed" class="mt-3">
                    <small class="d-block mb-2"><strong>Configuração de Campo Computado</strong></small>
                    
                    <SGPFormSelectComponent
                      label="Depende do campo"
                      name="depends_on"
                      :listaDeOptions="getCamposDisponiveis(linha.campos, i)"
                      optionLabel="label"
                      optionValue="name"
                      v-model="linha.campos[i].computed_depends_on"
                      placeholderText="Selecione o campo"
                      dense
                      outlined
                      mostrarSelecione
                      class="mb-2"
                    />

                    <SGPFormSelectComponent
                      label="Tipo de formatação"
                      name="format_type"
                      :listaDeOptions="formatosCamposComputados"
                      optionLabel="label"
                      optionValue="value"
                      v-model="linha.campos[i].computed_format"
                      placeholderText="Selecione o formato"
                      dense
                      outlined
                      mostrarSelecione
                    />

                    <small class="text-muted">
                      {{ getDescricaoFormato(linha.campos[i].computed_format) }}
                    </small>
                  </div>
                </div>

              </div>
            </draggable>
          </div>        
        </div>
      </draggable>

      <div class="pa-5 d-flex align-items-center justify-content-center">
        <SGPFormBotaoComponent fab x-small @click="inserirNovaLinha()">
          <SGPIconComponent>mdi-plus</SGPIconComponent>
        </SGPFormBotaoComponent>
      </div>

      <div class="action-buttons text-right">
        <!-- <SGPFormBotaoComponent color="light-blue darken-4" outlined class="text-capitalize mr-3" @click="gerenciarRegraExterna">
          <SGPIconComponent>mdi-relation-many-to-many</SGPIconComponent>
          Regras Externas
        </SGPFormBotaoComponent> -->

        <SGPFormBotaoComponent outlined class="text-capitalize mr-3" @click="gerarVisualizacao">
          <SGPIconComponent>mdi-fit-to-screen-outline</SGPIconComponent>
          Visualizar
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent v-if="$route.params.id" class="text-capitalize" @click.prevent="atualizarFormulario">
          <SGPIconComponent>mdi-update</SGPIconComponent>
          Atualizar Formulário
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent  v-else  class="text-capitalize" @click.prevent="salvarFormulario">
          <SGPIconComponent>mdi-plus</SGPIconComponent>
          Salvar Formulário
        </SGPFormBotaoComponent>
      </div>
    </div>

    <SGPModalComponent tamanho="lg"  v-if="mostrarModalVisualizacao" @sgpModalFechar="mostrarModalVisualizacao = false">
      <!-- <RenderizaFormularioComponent :dadosExternos="dadosExternos" v-if="jsonVisualizacao" :json="jsonVisualizacao"></RenderizaFormularioComponent> -->
      <ModalRenderizaFormularioComponent v-if="jsonVisualizacao" :json="jsonVisualizacao" :dadosExternos="dadosExternos" />
    </SGPModalComponent>

    <RegrasExternasComponent
      v-if="mostrarModalRegrasExternas"
      mostrarModalRegrasExternas="mostrarModalRegrasExternas"
      :form="rows"
      @fecharModalRegrasExternas="gerenciarRegraExterna"
    />

    <SGPLoadingComponent v-if="loadingFormularioDinamico"></SGPLoadingComponent>
   
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable'
import ModalRenderizaFormularioComponent from '../components/ModalRenderizaFormularioComponent.vue';
import CamposExpressoesComponent from '../components/CamposExpressoesComponent.vue';
import SubcampoFormComponent from '../components/SubcampoFormComponent.vue'
import RegrasExternasComponent from '../components/RegrasExternasComponent.vue'

import { montarFormularioPreview } from '../service/MontaFormularioDinamicoPreviewService.js'

export default {
  name: "NovoFormularioPage",

  components: {
    ModalRenderizaFormularioComponent,
    draggable,
    CamposExpressoesComponent,
    SubcampoFormComponent,
    RegrasExternasComponent
  },

  data () {
    return {
      mostrarModalRegrasExternas: false,
      dadosExternos: null,
      colunasLinha: [
        { text: '1 Coluna', value: 1 },
        { text: '2 Colunas', value: 2 },
        { text: '3 Colunas', value: 3 }
      ],
      rows: [
        {
          colunas: 1,
          campos: [
            {
              ctrl_campo_id: null,
              obrigatorio: null,
              ordem: 1,
              options: null,
              valor_padrao: null,
              ctrl_campo: {},
              mostrar_expressoes: false,
              mostrar_subcampos: false,
              expressoes_logicas: [],
              expressoes_logicas_externas: [],
              ctrl_formulario_subcampos: [],
              readonly: false,
              is_computed: false,
              computed_depends_on: null,
              computed_format: null
            }
          ]
        }
      ],

      rowDefault: {
        colunas: 1,
        campos: [
          {
            ctrl_campo_id: null,
            obrigatorio: null,
            ordem: 1,
            options: null,
            valor_padrao: null,
            ctrl_campo: {},
            mostrar_expressoes: false,
            expressoes_logicas: [],
            expressoes_logicas_externas: [],
            mostrar_subcampos: false,
            ctrl_formulario_subcampos: [],
            readonly: false,
            is_computed: false,
            computed_depends_on: null,
            computed_format: null
          }
        ]
      },

      campoDefault: {
        ctrl_campo_id: null,
        obrigatorio: null,
        ordem: 1,
        options: null,
        valor_padrao: null,
        ctrl_campo: {},
        mostrar_expressoes: false,
        mostrar_subcampos: false,
        expressoes_logicas: [],
        expressoes_logicas_externas: [],
        ctrl_formulario_subcampos: [],
        readonly: false,
        is_computed: false,
        computed_depends_on: null,
        computed_format: null
      },

      jsonVisualizacao: '',
      mostrarModalVisualizacao: false,
      mostrarModalExpressoesLogicas: false,
      titulo: '',
      campoSelecionado: {},
      formatosCamposComputados: [
        { label: 'Gerar Senha Automática', value: 'AUTO_GENERATE_PASSWORD' },
        { label: 'Prefixo + Timestamp', value: 'PREFIXO_TIMESTAMP' },
        { label: 'Timestamp', value: 'TIMESTAMP' },
        { label: 'UUID', value: 'UUID' },
        { label: 'Maiúsculas', value: 'UPPERCASE' },
        { label: 'Minúsculas', value: 'LOWERCASE' },
        { label: 'Capitalizar', value: 'CAPITALIZE' },
        { label: 'Copiar Valor', value: 'COPY' },
        { label: 'Concatenar', value: 'CONCAT' }
      ]
    }
  },

  async created () {
    await this.listarCamposSemPaginacao({ trashed: 0})
    this.listarExpressoesBooleanas()

    if (this.$route.params.id) {
      await this.recuperarFormularioDinamicoPorId(this.$route.params)
      this.carregarFormularioDinamicoParaEdicao()
    }
  },

  computed: {
    ...mapGetters("ctrlCampos", [
      "listaDeCtrlCampos",
      "loadingCampos"
    ]),

     ...mapGetters('ctrlFormularioDinamico', [
      'listaDeExpressoesBooleanas',
      'formularioDinamico',
      'loadingFormularioDinamico'
    ]),

    listaDeCampos () {
      if (this.listaDeCtrlCampos) {
        return this.listaDeCtrlCampos.data
      }
      return ''
    }
  }, 

  methods: {
    ...mapActions('ctrlCampos', [
      'listarCampos',
      'listarCamposSemPaginacao',
      'atualizarCampo',
      'deletarCampo'
    ]),

    ...mapActions('ctrlFormularioDinamico', [
      'salvarFormularioDinamico',
      'listarExpressoesBooleanas',
      'recuperarFormularioDinamicoPorId',
      'atualizarFormularioDinamico'
    ]),

    inserirCampoLinha(linha) {
      let indexColunas = linha.colunas
      for (let i = 0; i < indexColunas; i++) {
        if (linha.campos.length < linha.colunas) {
          let coluna = {
            ...this.campoDefault,
            expressoes_logicas: []
          }
          linha.campos.push(coluna)
        }

        if (linha.campos.length > linha.colunas) {
          linha.campos.splice(linha.colunas)
        }
      }      
    },

    getCampo (id) {
      return this.listaDeCampos.find(campo => campo.id == id)
    },

    gerarOptionsCampos (options) {
      let opcoes = [
          ...options.map(option => {
            return {
              label: option.label,
              value: option.val
            }
          })
        ]

      opcoes = opcoes.reduce((acc, item) => {
        acc[`${item.value}`] = item.label;
        return acc;
      }, {})

      return opcoes
    },

    gerarValidation (campo) {
      let validation = campo.obrigatorio ? 'required' : ''

      if (campo.ctrl_campo.min) {
        validation = validation ? `${validation}|min:${campo.ctrl_campo.min}` : `required|min:${campo.ctrl_campo.min}`
      }

      if (campo.ctrl_campo.max) {
        validation = validation ? `${validation}|max:${campo.ctrl_campo.max}` : `max:${campo.ctrl_campo.max}`
      }

      return validation
    },

    gerarCampo () {
      let campos = []
      
      this.rows.map((linha, linhaIndex) => {
        return linha.campos.map((campo) => {
          let ctrlCampo = this.getCampo(campo.ctrl_campo_id)
          
          // Montar objeto computed se o campo for computado
          let computedConfig = null;
          if (campo.is_computed && campo.computed_format) {
            computedConfig = {
              dependsOn: campo.computed_depends_on,
              format: campo.computed_format
            };
          }
          
          campos.push({
            ...ctrlCampo,
            linha: linhaIndex + 1,
            id: campo.ctrl_campo_id,
            label: ctrlCampo.label,
            type: ctrlCampo.campo_oculto ? 'hidden' : ctrlCampo.tipo_campo,
            name: ctrlCampo.name,
            placeholder: ctrlCampo.placeholder,
            desc_ajuda: ctrlCampo.desc_ajuda || '',
            value: campo.valor_padrao ? campo.valor_padrao : ctrlCampo.valor_padrao,
            show: ctrlCampo.campo_oculto ? false : this.validaRegraDeVizualizacaoCampo(campo),
            validation: this.gerarValidation(campo),
            validation_verify: this.gerarValidation(campo),
            col: 'col-md-' + 12 / linha.colunas,
            options: this.gerarOptionsCampos(ctrlCampo.ctrl_campos_opcoes),
            ctrl_formulario_subcampos: campo.ctrl_formulario_subcampos,
            indice_ficha: ctrlCampo.ctrl_indice_ficha_tecnica_id ? ctrlCampo.ctrl_indice_ficha_tecnica.indice : "",
            expressoes_logicas_externas: campo.expressoes_logicas_externas,
            readonly: campo.readonly || false,
            computed: computedConfig
          })

          if(campo.ctrl_formulario_subcampos.length) {
            campo.ctrl_formulario_subcampos.forEach(subcampo => {           
              let sub = {
                "id": campo.ctrl_campo_id,
                "label": subcampo.label,
                "type": "select-avancado",
                "options": this.gerarOptionsSubcampo(subcampo.options),
                "validation": subcampo.obrigatorio ? 'required' : '',
                "validation_verify": subcampo.obrigatorio ? 'required' : '',
                "name": subcampo.name,
                "nome_enderecamento": campo.ctrl_campo.name,
                "show": `(this.values.${campo.ctrl_campo.name} !== '') && ${ctrlCampo.campo_oculto ? false : this.validaRegraDeVizualizacaoCampo(campo)}`,
                "posicao": 1,
                "col": `col-md-${12 / linha.colunas}`,
                "placeholder": "",
                "desc_ajuda": "",
                "expressoes_logicas_externas": campo.expressoes_logicas_externas,
                "indice_ficha": ctrlCampo.ctrl_indice_ficha_tecnica_id ? ctrlCampo.ctrl_indice_ficha_tecnica.indice : ""
              }
              campos.push(sub)
            })
          }
        })
      })
      return campos;
    },

    gerarOptionsSubcampo (options) {
      let optionsData = {}
      options.forEach(option => {        
        if (optionsData[option.valor_comparacao] == null) {
          optionsData[option.valor_comparacao] = []
        }        
        optionsData[option.valor_comparacao].push(option)
      })

      // transforma tudo em objeto para não quebrar o backend,
      // que pede objeto ao invés de arrau no options dos campos de indice ficha tecnica
      for (const [key] of Object.entries(optionsData)) {        
          optionsData[key] = optionsData[key].reduce((acc, item) => {
          acc[`${item.value}`] = item.label;
          return acc;
        }, {})
      }

      return optionsData
    },

    async gerarVisualizacao () {
      let formulario = {
        titulo: this.titulo,
        col: 'col-md-12',
        corpo: this.gerarCampo()
      }

      montarFormularioPreview(formulario)

      this.jsonVisualizacao = formulario
      this.mostrarModalVisualizacao = true

      const dadosExternos = await localStorage.getItem('form_dinamico_dado_externo')
      if (dadosExternos) {
        this.dadosExternos = JSON.parse(dadosExternos)
      }
    },

    inserirNovaLinha() {
      this.rows.push({
        ...this.rowDefault,
        campos: [{...this.campoDefault}]
      })
    },

    deletarLinha(linha) {
      this.rows.splice(linha, 1)
    },

    alimentaValorPadrao (item) {
      let ctrlCampo = this.getCampo(item.ctrl_campo_id)

      if (ctrlCampo.min) {
        item.obrigatorio = true
      }

      item.ctrl_campo = ctrlCampo
      item.valor_padrao = ctrlCampo.valor_padrao
      item.options = ctrlCampo.ctrl_campos_opcoes ? ctrlCampo.ctrl_campos_opcoes.map(option => {
        return {
          label: option.label,
          value: option.val
        }
      }) : null
    },

    salvarFormulario() {
      let formulario = {
        titulo: this.titulo,
        col: 'col-md-12',
        corpo: this.gerarCampo(),
        rows: [...this.rows]
      }

      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.salvarFormularioDinamico(formulario)
          return;
        }
      });
    },

    atualizarFormulario () {
      let formDinamico = Array.isArray(this.formularioDinamico) ? this.formularioDinamico[0] : this.formularioDinamico
      let formulario = {
        ...formDinamico,
        titulo: this.titulo,
        corpo: this.gerarCampo(),
        rows: [...this.rows]
      }
      
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.atualizarFormularioDinamico(formulario)
          return;
        }
      });
    },

    recuperaExprsssoaBooleanaPorId(id) {
      return this.listaDeExpressoesBooleanas.find(exp => exp.id === id)
    },

    validaRegraDeVizualizacaoCampo (campo) {
      let listaDeRegras = []

      if (!campo.expressoes_logicas.length) return true
      
      campo.expressoes_logicas.map(exp => {
        const campoGatilho = this.getCampo(exp.ctrl_campo_id)
        const objExpressaoBooleana = this.recuperaExprsssoaBooleanaPorId(exp.ctrl_expressao_booleana_id)        
        const expressao = `this.values.${campoGatilho.name} ${objExpressaoBooleana.comando} ${exp.verificador ? "'" + exp.verificador + "'" : "''" }`
        listaDeRegras.push(expressao)
      })

      if (listaDeRegras.length) {
        return listaDeRegras.join(' && ')
      }

      return true
    },

    agruparPorLinha(form) {
      const resultado = [];
      form.forEach(obj => {
        if (!resultado[parseInt(obj.linha)-1]) {
          resultado[parseInt(obj.linha)-1] = {
            colunas: 1,
            campos: []
          }
        }

        resultado[parseInt(obj.linha)-1].colunas = form.length
        resultado[parseInt(obj.linha)-1].campos.push({
          ...obj, 
          colunas: form.length
        });
      })
      return resultado;
    },

    carregarFormularioDinamicoParaEdicao() {
      if (this.formularioDinamico == null) return
      let form = Array.isArray(this.formularioDinamico) ? this.formularioDinamico[0] : this.formularioDinamico

      this.titulo = form.titulo

      // Priorizar 'ctrl_campos_formulario' que tem as regras, ou usar 'corpo' como fallback
      let campos = form.ctrl_campos_formulario || form.corpo || []
      
      let rows = this.agruparPorLinha(campos)
      rows = rows.map(coluna => {
        
        return {
          ...coluna,
          colunas: coluna.campos.length,
          campos: coluna.campos.map(campo => {
            let campoId = campo.ctrl_campo_id || campo.id
            let ctrlCampo = this.getCampo(campoId)
            
            // Get computed from multiple sources (corpo array has the computed config)
            let computedConfig = campo.computed || campo.ctrl_campo?.computed || ctrlCampo?.computed || null
            
            // Se não encontrou, buscar no array corpo pelo campo ID
            if (!computedConfig && form.corpo) {
              const campoCorpo = form.corpo.find(c => c.id === campoId)
              if (campoCorpo && campoCorpo.computed) {
                computedConfig = campoCorpo.computed
              }
            }
            
            return {
              ctrl_campo_id: campoId,
              obrigatorio: campo.obrigatorio || null,
              ordem: campo.ordem || 1,
              valor_padrao: campo.valor_padrao || campo.value || null,
              ctrl_campo: campo.ctrl_campo || ctrlCampo || campo, // Priorizar ctrl_campo do response
              options: this.parseOptionsEdicao(
                campo.ctrl_campo?.ctrl_campos_opcoes || 
                campo.ctrl_campos_opcoes || 
                campo.options || 
                []
              ),
              mostrar_expressoes: false,
              mostrar_subcampos: false,
              expressoes_logicas: campo.pco_formulario_campo_regras || [],
              expressoes_logicas_externas: campo.pco_formulario_campo_regras_externas || [],
              ctrl_formulario_subcampos: campo.ctrl_formulario_subcampos || [],
              readonly: campo.readonly || campo.ctrl_campo?.readonly || ctrlCampo?.readonly || false,
              is_computed: !!(computedConfig && computedConfig.format),
              computed_depends_on: computedConfig?.dependsOn || null,
              computed_format: computedConfig?.format || null
            }
          })
        }
      })

      this.rows = rows
    },

    parseOptionsEdicao(options) {
      if (options) {
        return options.map(option => {
          return {
            ...option,
            value: option.val
          }
        })
      }
      return []
    },

    gerenciarRegraExterna () {
      this.mostrarModalRegrasExternas = !this.mostrarModalRegrasExternas
    },

    getCamposDisponiveis(campos, indiceCampoAtual) {
      // Retorna todos os campos da linha exceto o próprio campo atual
      return this.rows.flatMap(linha => 
        linha.campos
          .filter((campo, index) => campo.ctrl_campo_id && !(campos === linha.campos && index === indiceCampoAtual))
          .map(campo => ({
            name: campo.ctrl_campo?.name || `campo_${campo.ctrl_campo_id}`,
            label: campo.ctrl_campo?.label || `Campo ${campo.ctrl_campo_id}`
          }))
      );
    },

    getDescricaoFormato(formato) {
      const descricoes = {
        'AUTO_GENERATE_PASSWORD': 'Gera automaticamente uma senha aleatória quando o formulário for carregado',
        'PREFIXO_TIMESTAMP': 'Concatena o valor do campo dependente com a data/hora brasileira (ex: P_06/04/2026 14:30:45)',
        'TIMESTAMP': 'Insere a data/hora atual no formato DD/MM/AAAA HH:MM:SS',
        'UUID': 'Gera um UUID único',
        'UPPERCASE': 'Converte o valor do campo dependente para maiúsculas',
        'LOWERCASE': 'Converte o valor do campo dependente para minúsculas',
        'CAPITALIZE': 'Capitaliza a primeira letra do valor do campo dependente',
        'COPY': 'Copia o valor do campo dependente',
        'CONCAT': 'Concatena o valor com prefixo/sufixo'
      };
      return descricoes[formato] || '';
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.linha-formulario {
  background: $color-neutral-light;
  border: solid 1px $color-neutral-light;
  transition: all 0.8s;
  &:hover {
    background: $color-neutral-medium;
    border: solid 1px $color-neutral-dark;
  }
}
</style>